// Hierarchical tag recommendations based on hobbies
// Structure: hobby -> 1st order tags -> 2nd order tags -> 3rd order tags

export const tagHierarchy = {
  'Arts & Culture': {
    firstOrder: ['Book Clubs', 'Writing', 'Photography', 'Film & Cinema', 'Music (Performance)', 'Music (Listening)', 'Theater/Drama', 'Visual Arts/Painting'],
    secondOrder: {},
    thirdOrder: {}
  },
  'Social & Community': {
    firstOrder: ['Networking', 'Meetups', 'Neighborhood Groups', 'Young Professionals', 'Seniors', 'Alumni', 'History'],
    secondOrder: {},
    thirdOrder: {}
  },
  'Business': {
    firstOrder: ['Entrepreneurs', 'Startups', 'Investing', 'Real Estate', 'Freelancers', 'Women in Business', 'Small Business', 'Job Search'],
    secondOrder: {},
    thirdOrder: {}
  },
  'Games': {
    firstOrder: ['Computer Games', 'Card Games', 'Video Games', 'Board Games'],
    secondOrder: {},
    thirdOrder: {}
  },
  'Travel': {
    firstOrder: ['Travel Groups', 'Road Trips', 'Adventure Travel', 'Budget Travel', 'Solo Travel', 'Group Tours', 'Travel Photography'],
    secondOrder: {},
    thirdOrder: {}
  },
  'International': {
    firstOrder: ['Language Exchange', 'Cultural Exchange', 'Expat Communities', 'International Students', 'Diplomacy & Relations', 'Heritage'],
    secondOrder: {},
    thirdOrder: {}
  },
  'Hobbies & Crafts': {
    firstOrder: ['Gardening', 'Cooking', 'Board Games', 'Knitting/Sewing', 'DIY/Makers', 'Collecting'],
    secondOrder: {},
    thirdOrder: {}
  },
  'Learning & Discussion': {
    firstOrder: ['Science & Tech', 'Philosophy', 'History', 'Current Events', 'Study Groups', 'Public Speaking', 'Debate'],
    secondOrder: {},
    thirdOrder: {}
  },
  'Faith & Spirituality': {
    firstOrder: ['Catholic', 'Protestant/Christian', 'Jewish', 'Muslim', 'Buddhist', 'Hindu', 'Interfaith', 'Spiritual (Non-religious)'],
    secondOrder: {},
    thirdOrder: {}
  },
  'Politics & Civics': {
    firstOrder: ['Civic Engagement', 'Advocacy', 'Policy Discussion', 'Local Government', 'Environmental Action'],
    secondOrder: {},
    thirdOrder: {}
  },
  'Spirituality': {
    // User-friendly first tag choices (places / practices)
    firstOrder: ['Church', 'Temple', 'Mosque', 'Synagogue', 'Meditation', 'Yoga', 'Mindfulness', 'Non-denominational'],
    secondOrder: {
      'Church': ['Community', 'House Meetups', 'Student Fellowship', 'Weekly Service', 'Bible Study'],
      'Temple': ['Community', 'House Meetups', 'Student Fellowship', 'Weekly Service', 'Cultural Events'],
      'Mosque': ['Community', 'House Meetups', 'Student Fellowship', 'Weekly Service', 'Study Circle'],
      'Synagogue': ['Community', 'House Meetups', 'Student Fellowship', 'Weekly Service', 'Study Circle'],
      'Non-denominational': ['Community', 'House Meetups', 'Student Fellowship', 'Weekly Service'],
      'Meditation': ['Beginners', 'Advanced', 'Guided', 'Silent Practice'],
      'Yoga': ['Beginners', 'Intermediate', 'Advanced', 'Gentle', 'Power Yoga'],
      'Mindfulness': ['Beginners', 'Daily Practice', 'Weekly Sessions', 'Workshop']
    },
    thirdOrder: {
      'Community': ['Weekly', 'Monthly', 'Bi-weekly'],
      'House Meetups': ['Weekly', 'Bi-weekly', 'Monthly'],
      'Student Fellowship': ['Weekly', 'Bi-weekly'],
      'Young Adult': ['Monthly', 'Weekly', 'Daily', 'Bi-weekly'],
      'Senior': ['Weekly', 'Monthly', 'Bi-weekly'],
      'Youth': ['Weekly', 'Monthly'],
      'Family': ['Monthly', 'Weekly'],
      'College Students': ['Weekly', 'Bi-weekly', 'Monthly'],
      'Beginners': ['Weekly', 'Monthly', 'One-time Workshop'],
      'Advanced': ['Weekly', 'Daily', 'Monthly Retreat']
    }
  },
  'Sports': {
    firstOrder: ['Running', 'Basketball', 'Soccer', 'Tennis', 'Climbing', 'Swimming', 'Cycling', 'Hiking', 'Surfing', 'Boating', 'Martial Arts', 'Yoga', 'Pickup Games', 'Pickleball', 'Winter Sports', 'Gym'],
    secondOrder: {
      'Basketball': ['Indoor', 'Outdoor', 'Recreational', 'Competitive', 'Pick-up Games', 'Youth League', 'Senior League'],
      'Soccer': ['Recreational', 'Competitive', 'Indoor', 'Outdoor', 'Youth League'],
      'Tennis': ['Singles', 'Doubles', 'Beginners', 'Intermediate', 'Advanced', 'Social Play'],
      'Volleyball': ['Beach', 'Indoor', 'Recreational', 'Competitive', 'Mixed Gender'],
      'Running': ['Trail Running', 'Road Running', 'Marathon Training', 'Couch to 5K', 'Ultra Running'],
      'Cycling': ['Road Cycling', 'Mountain Biking', 'Urban Cycling', 'Long Distance', 'Commuter'],
      'Yoga': ['Hatha', 'Vinyasa', 'Ashtanga', 'Yin', 'Hot Yoga', 'Power Yoga'],
      'Martial Arts': ['Karate', 'Judo', 'Taekwondo', 'Jiu-Jitsu', 'Kung Fu']
    },
    thirdOrder: {
      'Recreational': ['Weekly', 'Bi-weekly', 'Monthly'],
      'Competitive': ['Weekly Practice', 'Tournament Prep', 'Monthly Competitions'],
      'Beginners': ['Weekly Classes', 'Monthly Workshops', 'One-time Intro'],
      'Intermediate': ['Weekly', 'Bi-weekly'],
      'Advanced': ['Weekly', 'Daily Training', 'Monthly Intensives'],
      'Trail Running': ['Weekly', 'Bi-weekly', 'Monthly', 'Beginner', 'Intermediate', 'Advanced'],
      'Road Running': ['Weekly', 'Bi-weekly', 'Monthly', '5K', '10K', 'Half Marathon'],
      'Marathon Training': ['Weekly', 'Bi-weekly', 'Long Runs', 'Speed Work'],
      'Couch to 5K': ['Weekly', 'Beginner', '8-10 Week Program'],
      'Ultra Running': ['Monthly', 'Trail', '50K+', 'Training Group']
    }
  },
  'Reading': {
    firstOrder: ['Fiction', 'Non-fiction', 'Science Fiction', 'Mystery', 'Biography', 'History', 'Self-help', 'Poetry', 'Classic Literature', 'Contemporary'],
    secondOrder: {
      'Fiction': ['Book Club', 'Novel Discussion', 'Short Stories', 'Literary Analysis'],
      'Non-fiction': ['Business Books', 'Science', 'Philosophy', 'History', 'Memoirs'],
      'Science Fiction': ['Book Club', 'Fan Discussion', 'Author Focus'],
      'Mystery': ['Book Club', 'Thriller Discussion', 'Crime Fiction'],
      'Poetry': ['Reading Group', 'Writing Workshop', 'Performance Poetry'],
      'Classic Literature': ['Book Club', 'Literary Analysis', 'Historical Context']
    },
    thirdOrder: {
      'Book Club': ['Monthly', 'Bi-weekly', 'Weekly'],
      'Reading Group': ['Monthly', 'Weekly'],
      'Writing Workshop': ['Monthly', 'Weekly', 'One-time']
    }
  },
  'Cooking': {
    firstOrder: ['Italian', 'Asian', 'Mexican', 'French', 'Baking', 'Vegetarian', 'Vegan', 'BBQ', 'Pastry', 'International'],
    secondOrder: {
      'Italian': ['Pasta Making', 'Pizza Making', 'Regional Cuisine', 'Wine Pairing'],
      'Asian': ['Sushi', 'Thai', 'Chinese', 'Indian', 'Korean'],
      'Baking': ['Bread Making', 'Pastry', 'Cakes', 'Cookies', 'Sourdough'],
      'Vegetarian': ['Plant-based Cooking', 'Meal Prep', 'Recipe Sharing'],
      'Vegan': ['Plant-based Cooking', 'Meal Prep', 'Recipe Sharing'],
      'BBQ': ['Grilling', 'Smoking', 'Outdoor Cooking', 'Competition BBQ']
    },
    thirdOrder: {
      'Pasta Making': ['Monthly Workshop', 'Weekly Classes', 'One-time'],
      'Recipe Sharing': ['Monthly Potluck', 'Weekly Cooking', 'Bi-weekly'],
      'Grilling': ['Monthly BBQ', 'Weekly', 'Seasonal']
    }
  },
  'Music': {
    firstOrder: ['Rock', 'Jazz', 'Classical', 'Electronic', 'Hip Hop', 'Country', 'Folk', 'Blues', 'Singing', 'Instruments'],
    secondOrder: {
      'Rock': ['Band Practice', 'Concert Going', 'Album Discussion'],
      'Jazz': ['Jam Sessions', 'Live Music', 'Music Theory'],
      'Classical': ['Concert Going', 'Music Appreciation', 'Performance'],
      'Singing': ['Choir', 'Karaoke', 'Vocal Training', 'A Cappella'],
      'Instruments': ['Guitar', 'Piano', 'Drums', 'Violin', 'Ukulele']
    },
    thirdOrder: {
      'Band Practice': ['Weekly', 'Bi-weekly', 'Monthly'],
      'Jam Sessions': ['Weekly', 'Monthly'],
      'Concert Going': ['Monthly', 'Bi-weekly'],
      'Choir': ['Weekly Rehearsal', 'Bi-weekly', 'Seasonal']
    }
  },
  'Programming': {
    firstOrder: ['Web Development', 'Mobile Development', 'Data Science', 'Machine Learning', 'Game Development', 'Open Source', 'Algorithm Practice', 'Coding Bootcamp'],
    secondOrder: {
      'Web Development': ['Frontend', 'Backend', 'Full Stack', 'React', 'Node.js', 'Python'],
      'Mobile Development': ['iOS', 'Android', 'React Native', 'Flutter'],
      'Data Science': ['Python', 'R', 'SQL', 'Data Visualization', 'Statistics'],
      'Machine Learning': ['Deep Learning', 'NLP', 'Computer Vision', 'Projects'],
      'Game Development': ['Unity', 'Unreal Engine', 'Indie Games', 'Game Design']
    },
    thirdOrder: {
      'Frontend': ['Weekly Meetup', 'Monthly Hackathon', 'Bi-weekly'],
      'Projects': ['Weekly Collaboration', 'Monthly Showcase', 'Continuous'],
      'Practice': ['Weekly', 'Daily Challenges', 'Monthly Competition']
    }
  },
  'Photography': {
    firstOrder: ['Portrait', 'Landscape', 'Street Photography', 'Wildlife', 'Event Photography', 'Nature', 'Urban', 'Macro', 'Travel'],
    secondOrder: {
      'Portrait': ['Beginners', 'Intermediate', 'Advanced', 'Studio', 'Natural Light'],
      'Landscape': ['Sunrise/Sunset', 'Nature', 'Urban Landscapes', 'Long Exposure'],
      'Street Photography': ['Photo Walks', 'Urban Exploration', 'Documentary'],
      'Wildlife': ['Bird Watching', 'Nature', 'Safari', 'Animal Behavior']
    },
    thirdOrder: {
      'Photo Walks': ['Monthly', 'Weekly', 'Bi-weekly'],
      'Workshop': ['Monthly', 'One-time', 'Multi-day'],
      'Outing': ['Monthly', 'Bi-weekly', 'Seasonal']
    }
  },
  'Hiking': {
    firstOrder: ['Day Hikes', 'Overnight Camping', 'Backpacking', 'Trail Running', 'Nature Photography', 'Scenic Views', 'Mountain Climbing'],
    secondOrder: {
      'Day Hikes': ['Easy', 'Moderate', 'Strenuous', 'All Levels'],
      'Overnight Camping': ['Weekend', 'Multi-day', 'Car Camping'],
      'Backpacking': ['Beginner', 'Intermediate', 'Advanced', 'Long Distance'],
      'Trail Running': ['Trail Running', 'Ultra Running', 'Fast Packing']
    },
    thirdOrder: {
      'Easy': ['Weekly', 'Bi-weekly', 'Monthly'],
      'Moderate': ['Monthly', 'Bi-weekly'],
      'Weekend': ['Monthly', 'Seasonal'],
      'Beginner': ['Monthly', 'One-time Intro']
    }
  },
  'Volunteering': {
    firstOrder: ['Adaptive Sports', 'Animal Welfare', 'Environmental', 'Food Banks & Hunger', 'Habitat & Housing', 'Youth Mentoring', 'Senior Care', 'Disaster Relief', 'Health & Wellness', 'Education & Literacy', 'Community Cleanup', 'Home Care'],
    secondOrder: {},
    thirdOrder: {}
  }
};

// Helper function to get 1st order tags for a hobby (case-insensitive)
export const getFirstOrderTags = (hobby) => {
  if (!hobby) return [];
  
  // Try exact match first
  if (tagHierarchy[hobby]) {
    return tagHierarchy[hobby].firstOrder || [];
  }
  
  // Try case-insensitive match
  const hobbyLower = hobby.toLowerCase();
  for (const [key, value] of Object.entries(tagHierarchy)) {
    if (key.toLowerCase() === hobbyLower) {
      return value.firstOrder || [];
    }
  }
  
  // If no match found, return empty array
  console.log(`No tag hierarchy found for hobby: "${hobby}"`);
  return [];
};

// Helper function to get 2nd order tags based on hobby and 1st tag
export const getSecondOrderTags = (hobby, firstTag) => {
  if (!hobby || !firstTag) return [];

  // Find hobby key case-insensitively
  const hobbyKey = Object.keys(tagHierarchy).find(k => k.toLowerCase() === String(hobby).toLowerCase());
  if (!hobbyKey) return [];
  if (!tagHierarchy[hobbyKey].secondOrder) return [];

  // Find firstTag key case-insensitively (so "church" works)
  const secondOrderMap = tagHierarchy[hobbyKey].secondOrder;
  const firstTagKey = Object.keys(secondOrderMap).find(k => k.toLowerCase() === String(firstTag).toLowerCase());
  if (!firstTagKey) return [];

  return secondOrderMap[firstTagKey] || [];
};

// Helper function to get 3rd order tags based on hobby, 1st tag, and 2nd tag
export const getThirdOrderTags = (hobby, firstTag, secondTag) => {
  if (!hobby || !secondTag) return [];
  const hobbyKey = Object.keys(tagHierarchy).find(k => k.toLowerCase() === String(hobby).toLowerCase());
  if (!hobbyKey || !tagHierarchy[hobbyKey].thirdOrder) return [];

  const thirdOrderMap = tagHierarchy[hobbyKey].thirdOrder;
  const secondTagKey = Object.keys(thirdOrderMap).find(k => k.toLowerCase() === String(secondTag).toLowerCase());
  if (secondTagKey) {
    return thirdOrderMap[secondTagKey] || [];
  }

  // Fallback: return common 3rd order tags if no specific mapping
  return ['Monthly', 'Weekly', 'Bi-weekly', 'Daily', 'One-time'];
};

// Semantic tag matching - tags that are related/synonymous
export const semanticTagMap = {
  'Protestant': ['Christian', 'Evangelical', 'Baptist', 'Methodist', 'Lutheran', 'Presbyterian'],
  'Catholic': ['Roman Catholic', 'Christian', 'Catholicism'],
  'Church': ['Christian', 'Worship', 'Service', 'Fellowship'],
  'Temple': ['Hindu', 'Buddhist', 'Worship', 'Prayer'],
  'Mosque': ['Muslim', 'Islam', 'Prayer', 'Community'],
  'Synagogue': ['Jewish', 'Judaism', 'Prayer', 'Community'],
  'Young Adult': ['Young Adults', 'YA', 'College Age', 'Early Career'],
  'Senior': ['Seniors', 'Older Adults', 'Retirees'],
  'Youth': ['Teens', 'Teenagers', 'High School', 'Adolescents'],
  'Monthly': ['Once a month', 'Monthly meetings', 'Monthly gatherings'],
  'Weekly': ['Weekly meetings', 'Every week', 'Weekly sessions'],
  'Bi-weekly': ['Biweekly', 'Twice a month', 'Fortnightly'],
  'Daily': ['Daily practice', 'Every day', 'Daily sessions'],
  'Recreational': ['Casual', 'Social', 'Fun', 'Non-competitive'],
  'Competitive': ['Competition', 'Tournament', 'League'],
  'Beginners': ['Beginner', 'Novice', 'Starting out', 'New to'],
  'Book Club': ['Reading Group', 'Book Discussion', 'Literary Circle'],
  'Fiction': ['Novels', 'Stories', 'Literary Fiction']
};

// Check if two tags are semantically related
export const areTagsSemanticallyRelated = (tag1, tag2) => {
  const t1 = tag1.toLowerCase().trim();
  const t2 = tag2.toLowerCase().trim();
  
  // Exact match
  if (t1 === t2) return true;
  
  // Check semantic map
  for (const [key, related] of Object.entries(semanticTagMap)) {
    const keyLower = key.toLowerCase();
    if (t1 === keyLower && related.some(r => r.toLowerCase() === t2)) return true;
    if (t2 === keyLower && related.some(r => r.toLowerCase() === t1)) return true;
  }
  
  // Partial match (one contains the other)
  if (t1.includes(t2) || t2.includes(t1)) return true;
  
  return false;
};

